//** Import Modules */
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

//** Import Assets */
import "./styles/index.scss";

//** Import Components */
import App from "./App";
import { store } from "./features/store";

//** Import Web Socket */
import { socket, SocketContext } from "./contexts/SocketIO";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <SocketContext.Provider value={socket}>
          <App />
        </SocketContext.Provider>
      </Router>
    </Provider>
  </React.StrictMode>
);
